import { DEBT_ADDITION_REASON, PRODUCT_RETURN_OPTION, DEBT_REDUCTION_REASON, PRODUCT_RECEIVE_OPTION } from "../constants/Common"

export const DEBT_REDUCTION_REASONS = [
  {
    value: DEBT_REDUCTION_REASON.PRODUCT_PRICE_REDUCTION,
    label: 'ลดราคาสินค้า',
  },
  {
    value: DEBT_REDUCTION_REASON.SERVICE_PRICE_REDUCTION,
    label: 'ลดราคาค่าบริการ',
  },
  {
    value: DEBT_REDUCTION_REASON.PRODUCT_RETURN,
    label: 'ได้รับคืนสินค้า',
  },
  {
    value: DEBT_REDUCTION_REASON.COMPENSATION_PAYMENT,
    label: 'จ่ายเงินชดเชย',
  },
  {
    value: DEBT_REDUCTION_REASON.ADVANCE_REFUND,
    label: 'จ่ายเงินคืนเงินล่วงหน้า เงินมัดจำ เงินประกัน เงินจอง',
  },
  {
    value: DEBT_REDUCTION_REASON.BUSINESS_EXCHANGE,
    label: 'ได้รับคืนสินค้า หรือแลกเปลี่ยนสินค้า',
  },
  {
    value: DEBT_REDUCTION_REASON.CUSTOMER_EXCHANGE,
    label: 'ได้รับคืนสินค้า หรือแลกเปลี่ยนสินค้า',
  },
  {
    value: DEBT_REDUCTION_REASON.SERVICE_CANCELLATION_AGREEMENT,
    label: 'บอกเลิกบริการ',
  },
  {
    value: DEBT_REDUCTION_REASON.SERVICE_CANCELLATION_BREACH,
    label: 'บอกเลิกบริการ',
  },
  {
    value: DEBT_REDUCTION_REASON.SERVICE_CANCELLATION_BREACH,
    label: 'บอกเลิกบริการ',
  },
  {
    value: DEBT_REDUCTION_REASON.OTHER,
    label: 'อื่นๆ',
  },
]

export const DEBT_ADDITION_REASONS = [
  {
    value: DEBT_ADDITION_REASON.PRODUCT_PRICE_INCREASE,
    label: 'เพิ่มราคาสินค้า',
  },
  {
    value: DEBT_ADDITION_REASON.SERVICE_PRICE_INCREASE,
    label: 'เพิ่มราคาบริการ',
  },
  {
    value: DEBT_ADDITION_REASON.OTHER,
    label: 'อื่นๆ',
  },
]

export const PRODUCT_RETURN_OPTIONS = [
  { value: PRODUCT_RETURN_OPTION.ALL_RETURN, label: 'คืนสินค้า' },
  { value: PRODUCT_RETURN_OPTION.NO_RETURN, label: 'ไม่คืนสินค้า' },
]

export const PRODUCT_RECEIVE_OPTIONS = [
  { value: PRODUCT_RECEIVE_OPTION.RECEIVE_MORE, label: 'รับสินค้าเพิ่ม' },
  { value: PRODUCT_RECEIVE_OPTION.NOT_RECEIVE_MORE, label: 'ไม่รับสินค้าเพิ่ม' },
]
